import EventShowContainer from './event_show_container';

const EventShow = EventShowContainer;

export default EventShow;
